import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as api from '../../api';
import {isPhone, redirect} from '../../helpers';
import Button from '../button/button';

export class GameNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      percentToNextLevel: 0
    }
  }

  componentDidMount() {
    const {user} = this.props;
    if (!user) return
    api.getChild(user.currentChildId).then(data => this.setState({percentToNextLevel: data.percent_to_next_level}))
  }

  clickGame(url) {
    if (isPhone()) return window.location.assign(url);
    return redirect(url);
  }

  render() {

    const {user} = this.props;
    const {is_audio_playing} = this.props;
    return <div className="game-nav">
      {user && <div className="game-nav__content">
        <div className="game-nav__menu">
          <button className={'map-nav__btn map-nav__sound' + (is_audio_playing ? '' : ' __mute')}
                  onClick={() => this.toggleAudioPlay()}/>
          <Button
            mod="map-nav__home"
            onClick={() => {
              this.clickGame(localStorage.getItem('gameReturnLInk') || '/games')
            }}
            color="orange">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M30.0008 17.4026L20.4358 10.5359C20.1611 10.3547 19.8315 10.3547 19.5751 10.5359L10.0101 17.4026C9.27757 17.8859 9.58889 19.1142 10.4496 19.1142C10.9074 19.1142 11.292 19.517 11.292 20.0405V27.8737C11.292 28.3772 11.6582 28.8 12.1344 28.8H16.2479C16.6691 28.8 17.0171 28.4174 17.0171 27.9543V23.3832C17.0171 22.4569 17.6946 21.7119 18.537 21.7119H21.5105C22.3529 21.7119 23.0304 22.4569 23.0304 23.3832V27.914C23.0304 28.3772 23.3784 28.7597 23.7996 28.7597H27.9131C28.3709 28.7597 28.7555 28.357 28.7555 27.8335V20.0204C28.7555 19.517 29.1218 19.0941 29.5979 19.0941C30.4037 19.0941 30.715 17.8657 30.0008 17.4026Z"
                fill="white"/>
            </svg>
          </Button>
        </div>
      </div>}
    </div>
  }

  /**
   * Переключает аудио
   */
  toggleAudioPlay() {
    this.props.toggleAudioPlayingState();
  }
}

GameNav.propTypes = {
  toggleAudioPlayingState: PropTypes.func,
  is_audio_playing: PropTypes.bool
};
